export const internalTenantTypeRegEx = /^(sandbox|developer|sales_demo|debug)$/i;
